module.exports = __webpack_public_path__ + "img/icon-wireless.0fdac1f0.png";